// The page body every full-width app page sits in (owner, 2026-09-18:
// "center the review center layout", "SaaS padding left and right" on
// Technical documentation). Centred, capped, with a gutter that shrinks
// on a phone - one component so every page that uses it lines up with
// the others.
//
//   <PageContainer>...</PageContainer>          max 1280 px
//   <PageContainer wide>...</PageContainer>     max 1440 px (dense tables)
import React from "react";

export default function PageContainer({ wide = false, style = {}, children, ...rest }) {
  return (
    <div
      {...rest}
      style={{
        maxWidth: wide ? 1440 : 1280,
        margin: "0 auto",
        padding: "24px clamp(16px, calc(3 * var(--vw)), 32px)",
        boxSizing: "border-box",
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
